import { observer } from 'mobx-react-lite';
import { Container, Menu, Segment } from 'semantic-ui-react';
import ReportIssueForm from '../../features/user/ReportIssueForm';
import { useStore } from '../stores/store';
import { isMobileOnly } from 'react-device-detect';

export default observer(function Footer() {
    const {userStore, modalStore} = useStore();
    const {user} = userStore;
    const {openModal} = modalStore;
    
    return (
        <Segment basic className='text-center'>
            {user &&
            <Container className='footer-menu-container'>
                <Menu inverted compact 
                    size='large' 
                    className='logo-bg-color' 
                    stackable 
                    fluid={isMobileOnly ? true : false}
                >
                    <Menu.Item target='_blank' href='http://www.wsdot.wa.gov/ferries/fares/'>
                        Fares
                    </Menu.Item>
                    <Menu.Item target='_blank' href='http://www.wsdot.wa.gov/ferries/pdf/WashingtonStateFerries-RouteMap.pdf'>
                        Route Maps
                    </Menu.Item>
                    <Menu.Item target='_blank' href='http://www.wsdot.wa.gov/ferries/vesselwatch/terminals.aspx'>
                        Find Terminals
                    </Menu.Item>
                    <Menu.Item target='_blank' href='http://www.wsdot.wa.gov/ferries/vesselwatch/cameradetail.aspx'>
                        Ferry Cameras
                    </Menu.Item>
                    <Menu.Item target='_blank' href='https://wsdot.com/Travel/Real-time/Map/'>
                        Commuter Center
                    </Menu.Item>
                    <Menu.Item target='_blank' href='https://wsdot.wa.gov/Ferries/RouteAlerts'>
                        Ferry Alerts
                    </Menu.Item>
                    <Menu.Item onClick={() => openModal(<ReportIssueForm />, '', false)}>
                        Contact Us
                    </Menu.Item>
                </Menu>
            </Container>}
            Copyright Washington State Ferries © {new Date().getFullYear()}<br />
            Version {process.env.REACT_APP_VERSION}
        </Segment>
    )
})